import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/course-reviews/`;
const pathById = `${pathBase}:reviewId`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const courseReviews = {
  getAll: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
} as const;
